import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiRequest, assetUrl } from "../api/client";
import { brand, navLinks } from "../data/siteData";
import logo from "../assets/logo.png";

export default function Footer() {
  const [settings, setSettings] = useState(null);

  // useEffect(() => {
  //   apiRequest("/api/settings/public")
  //     .then((response) => setSettings(response.data))
  //     .catch(() => {});
  // }, []);

  const socialLinks = settings?.social_links || {};

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <Link to="/" className="logo">
          <img src={assetUrl(settings?.logo_url, logo)} alt="" />
          <small>{settings?.website_name || brand.name}</small>
        </Link>

        <div className="footer-links">
          {navLinks.map((link) => (
            <Link key={link.path} to={link.path}>
              {link.label}
            </Link>
          ))}

          <a
            href={socialLinks.instagram || "https://www.instagram.com/moatazhafez.mh/"}
            target="_blank"
            rel="noreferrer"
          >
            Instagram
          </a>

          <a
            href={socialLinks.tiktok || "https://www.tiktok.com/@moatazhafez_mh"}
            target="_blank"
            rel="noreferrer"
          >
            TikTok
          </a>
        </div>

        <p>
          © 2026 {settings?.website_name || brand.name} Fitness Coach. All rights reserved.
          {" "}Developed by{" "}
<a
  href="https://wa.me/201117766693"
  target="_blank"
  rel="noreferrer"
  style={{ color: "var(--accent)" }}
>
  Hatem Elaraby
</a>
        </p>
      </div>
    </footer>
  );
}